export default class Calculator {
   private formParts: HTMLInputElement[];
   private form: HTMLFormElement;
   private summaryWrapper: HTMLElement;
   private loader: HTMLElement;
   private readonly ACTION_NAME: string;

   constructor() {
      this.formParts = [
         ...document.querySelectorAll('.form__range-input'),
         ...document.querySelectorAll('.form__radios-container input'),
         document.querySelector('.form__checkbox input'),
      ] as HTMLInputElement[];
      this.form = document.querySelector('.form') as HTMLFormElement;
      this.summaryWrapper = document.querySelector('.summary__wrapper') as HTMLElement;
      this.loader = document.querySelector('.calculator__loader') as HTMLElement;
      this.ACTION_NAME = 'calculator';

      this.initListeners();
   }

   initListeners = async (): Promise<void> => {
      this.formParts.forEach((input) => input.addEventListener('change', this.handleInputChange));
   };

   handleInputChange = async (): Promise<void> => {
      await this.toggleLoader();
      const formData = await this.getFormData();
      const response = await fetch(window.global_vars.ajax, { method: 'POST', body: formData });
      const res = await response.json();

      this.summaryWrapper.innerHTML = res.summary;

      await this.toggleLoader();
   };

   toggleLoader = (): Promise<void> => {
      return new Promise((reject) => {
         this.loader.classList.toggle('calculator__loader--visible');
         reject();
      });
   };

   getFormData = (): Promise<FormData> => {
      return new Promise((resolve) => {
         const formData = new FormData(this.form);
         formData.append('action', this.ACTION_NAME);
         resolve(formData);
      });
   };
}
